export const GOAL = 'goal';
export const POINT = 'point';
export const SCORE = 'score';
export const _7M_GOAL = '7m_goal';
export const _10M_GOAL = '10m_goal';
export const PENALTY_GOAL = 'penalty_goal';
export const OWN_GOAL = 'own_goal';
